module.exports = __webpack_public_path__ + "static/media/banner.b78a1bd3.png";